import api from './api';

const API_URL = '/preps';

export const getAllPreps = async (storeId) => {
  try {
    const response = await api.get(API_URL, { params: { storeId } });
    return response.data;
  } catch (error) {
    console.error('Error fetching preps:', error);
    throw error;
  }
};

export const getPrepById = async (id) => {
  try {
    const response = await api.get(`${API_URL}/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching prep:', error);
    throw error;
  }
};

export const createPrep = async (prepData) => {
  try {
    const response = await api.post(API_URL, prepData);
    return response.data;
  } catch (error) {
    console.error('Error creating prep:', error);
    throw error;
  }
};

export const updatePrep = async (id, prepData) => {
  try {
    const response = await api.put(`${API_URL}/${id}`, prepData);
    return response.data;
  } catch (error) {
    console.error('Error updating prep:', error);
    throw error;
  }
};

export const deletePrep = async (id) => {
  try {
    const response = await api.delete(`${API_URL}/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting prep:', error);
    throw error;
  }
};